export default __webpack_public_path__ + "static/media/continue-reading.282e753e.svg";